import { useMemo } from "react";
import useEvent from "react-use-event-hook";

import { IHubSettingsGridItem, useDrawers } from "@ryde/shared";

import { parseHubSettingsGridItems } from "./hub-stations-cell.utils";

export const useHubStationsTemplate = ({ value }: { value: unknown }) => {
  const { openEditFormDrawer } = useDrawers();

  const items = useMemo<IHubSettingsGridItem[]>(() => {
    return parseHubSettingsGridItems(value);
  }, [value]);

  const firstItem = items[0];

  const openStation = useEvent((stationId: number) => {
    openEditFormDrawer({
      entity: "station",
      id: stationId,
    });
  });

  return {
    items,
    firstItem,
    openStation,
  };
};
